import { useEffect, useRef, useState } from 'react';
import { Icon } from './DesignSystem';
import { VersionsView } from './VersionsView';
import './NavigationPanel.css';
import { useWindows, type WindowState } from './Windows';

type ViewType = 'quest' | 'versions' | string;

const EnableNavigationPanel = false
export function NavigationPanel() {
  const [activeView, _setActiveView] = useState<ViewType>('quest');
  const [customViews, setCustomViews] = useState<string[]>(['view-1']);
  const windowStateRef = useRef<{
    [viewType: ViewType]: WindowState['windows'];
  }>({});
  const { state: windowState, dispatch: windowDispatch } = useWindows();

  function setActiveView(newActiveView: ViewType) {
    const existingWindowState = windowStateRef.current;
    windowStateRef.current = {
      ...existingWindowState,
      [activeView]: windowState.windows,
    };
    _setActiveView(newActiveView);
  }

  useEffect(() => {
    const windows = windowStateRef.current[activeView];
    if (windows === undefined) {
      return;
    }

    windowDispatch({ type: 'replace-windows', windows });
  }, [activeView, windowDispatch]);

  const handleAddView = () => {
    const newViewId = `view-${customViews.length + 1}`;
    setCustomViews([...customViews, newViewId]);
    setActiveView(newViewId);
  };

  function ActiveView({ activeView }: { activeView: ViewType }) {
    if (activeView === 'versions') {
      return <VersionsView />;
    }

    return <></>;
  }

  if (!EnableNavigationPanel) {
    return <></>
  }

  return (
    <>
      <div className="navigation-panel">
        <div className="nav-section">
          <button
            className={`neumorphic-button ${activeView === 'quest' ? 'active' : ''}`}
            onClick={() => setActiveView('quest')}
            title="Quest View"
          >
            <Icon type="map" />
          </button>
          <button
            className={`neumorphic-button ${activeView === 'versions' ? 'active' : ''}`}
            onClick={() => setActiveView('versions')}
            title="Versions"
          >
            <Icon type="versions" />
          </button>
        </div>

        <div className="nav-divider" />

        <div className="nav-section">
          {customViews.map((viewId) => (
            <button
              key={viewId}
              className={`neumorphic-button ${activeView === viewId ? 'active' : ''}`}
              onClick={() => setActiveView(viewId)}
              title={`Custom View ${viewId}`}
            >
              <Icon type="window-maximize" />
            </button>
          ))}

          <button
            className="neumorphic-button add-button"
            onClick={handleAddView}
            title="Create New View"
          >
            <Icon type="plus" />
          </button>
        </div>
        <ActiveView activeView={activeView} />
      </div>
    </>
  );
}
